import { render } from "./DanhSachChuyenDi.vue?vue&type=template&id=124c3148"
import script from "./DanhSachChuyenDi.vue?vue&type=script&lang=js"
export * from "./DanhSachChuyenDi.vue?vue&type=script&lang=js"

import "./DanhSachChuyenDi.vue?vue&type=style&index=0&id=124c3148&lang=css"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__